// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__wpwOO","author":"Table_author__1UILM","authorImage":"Table_authorImage__ya8Cg","unreadRow":"Table_unreadRow__1QhRk"};